import { IFeatureBase } from '../../models/features';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface ICreateFeatureProps {
  key: string;
  name: string;
}

export interface INewFeature extends IFeatureBase {
  featureGroupsCount: number;
}

export const createFeaturesService = async ({
  key,
  name,
}: ICreateFeatureProps): Promise<INewFeature> => {
  const { data } = await jhsfBookingsApi.post<INewFeature>('/features', {
    key,
    name,
  });

  return data;
};
